// src\themes\choopar\components\animations\textReveal.ts


export const textGroupVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.35,
            delayChildren: 0.15,
        },
    },
};


export const textItemVariants = {
    hidden: {
        opacity: 0,
        y: 34,
        filter: 'blur(10px)',
    },
    visible: {
        opacity: 1,
        y: 0,
        filter: 'blur(0px)',
        transition: {
            duration: 1.3,
            ease: [0.22, 1, 0.36, 1] as const,
        },
    },
};